"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLink = void 0;
var LinkBuilderFactory_1 = require("./LinkBuilderFactory");
var WebSocketClientFactory_1 = require("./WebSocketClientFactory");
var TransportHttpFactory_1 = require("./TransportHttpFactory");
var TransportWebSocketFactory_1 = require("./TransportWebSocketFactory");
var getGqlEndpoint = function (endpoint) {
    var finalEndpoint = endpoint;
    if (typeof localStorage !== 'undefined') {
        try {
            var debugEndpoint = localStorage.getItem('gql-endpoint');
            if (debugEndpoint) {
                console.warn("\n\n\n\nWARNING!\n\nUSING GQL ENDPOINT: \"" + debugEndpoint + "\"\n\n\n\n\n");
                finalEndpoint = "//" + debugEndpoint;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    return finalEndpoint;
};
var createLink = function (_a) {
    var endpoint = _a.endpoint, subscriptionEndpoint = _a.subscriptionEndpoint, token = _a.token, _b = _a.transport, transport = _b === void 0 ? 'websocket' : _b, webSocketClientOptions = _a.webSocketClientOptions, headers = _a.headers;
    var transportFactory;
    var linkBuilderFactory = new LinkBuilderFactory_1.LinkBuilderFactory();
    if (transport === 'websocket' &&
        typeof window !== 'undefined' &&
        ('WebSocket' in window || 'MozWebSocket' in window)) {
        var subscriptionClientFactory = new WebSocketClientFactory_1.WebSocketClientFactory();
        transportFactory = new TransportWebSocketFactory_1.TransportWebSocketFactory(linkBuilderFactory, {
            token: token,
            uri: getGqlEndpoint(subscriptionEndpoint || endpoint),
            webSocketClientOptions: webSocketClientOptions,
            headers: headers,
        }, subscriptionClientFactory);
    }
    else {
        // NOTE: HTTP transport does not support "subscriptions"
        transportFactory = new TransportHttpFactory_1.TransportHttpFactory(linkBuilderFactory, {
            token: token,
            uri: getGqlEndpoint(endpoint),
            headers: headers,
        });
    }
    return transportFactory.make();
};
exports.createLink = createLink;
//# sourceMappingURL=utils.js.map